import Spinner from './Spinner';

type LoaderProps = {
  variant: 'app' | 'modal' | 'page' | 'section' | 'inline';
  showLoader?: boolean;
  loaderText?: string;
};

const Loader = ({ variant, showLoader = true, loaderText }: LoaderProps) => {
  if (!showLoader) {
    return null;
  }

  return (
    <div className={`${variant}-loader-container`}>
      <Spinner className={`${variant}-loader`} />
      {loaderText && <div className={`${variant}-loader-text`}>{loaderText}</div>}
    </div>
  );
};

export default Loader;
